import { useContext, useState } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import _ from 'lodash';
import { store } from '../store';
import ColorModal from './ColorModal';
import SaveModal from './SaveModal';

const ColorPalette = () => {
  const { referenceColors } = useContext(store);
  const [selectedColor, setSelectedColor] = useState(null);

  const grouped = Object.entries(_.groupBy(referenceColors, 'group'));

  return (
    <div>
      {grouped.map(([groupName, data]) => (
        <Segment.Group key={groupName}>
          <Segment>{groupName}</Segment>
          {data.map(({ color, label }) => (
            <Segment
              key={color}
              style={{
                width: 200,
                height: 200,
                backgroundColor: color,
                cursor: 'pointer',
              }}
              circular
              onClick={() => setSelectedColor({ color, label })}
            >
              <Header as="h2">
                {label}
                {color !== label && (
                  <Header.Subheader>{color}</Header.Subheader>
                )}
              </Header>
            </Segment>
          ))}
        </Segment.Group>
      ))}
      <ColorModal
        title={selectedColor?.label}
        color={selectedColor?.color}
        close={() => setSelectedColor(null)}
      />
      <SaveModal />
    </div>
  );
};

export default ColorPalette;
